import React, { FC } from 'react'
import { Backdrop, CircularProgress, Typography } from '@mui/material'
//import { Theme } from '@material-ui/core/styles'
// import { createStyles, makeStyles } from '@mui/styles';
//import { Variant } from '@material-ui/core/styles/createTypography'
import theme from '../../../common/theme/theme';

// const useStyles = makeStyles((theme: any) =>    // Theme
//   createStyles({
//     backdrop: {
//       zIndex: theme.zIndex.drawer + 1,
//       color: '#fff',
//       opacity: '0.3',
//     },
//     progress: {
//       height: '100px !important',
//       width: '100px !important',
//     },
//   })
// )

interface ISpinnerTextProps {
  title: string
  variant: any//Variant
}

export default function LoadingSpinnerBackdrop() {
  // const classes = useStyles()
  const [progress, setProgress] = React.useState(0)

  React.useEffect(() => {
    function tick() {
      setProgress(oldProgress => (oldProgress >= 100 ? 0 : oldProgress + 1))
    }

    const timer = setInterval(tick, 80)
    return () => {
      clearInterval(timer)
    }
  }, [])

  return (
    <div>
      <Backdrop sx={{zIndex: theme.zIndex.drawer + 1,
                     color: '#fff',
                     opacity: '0.3',}}
        open>
        <CircularProgress
          variant="determinate"
          value={progress}
          sx={{ width: '100px !important', height: '100px !important' }}
        />
      </Backdrop>
    </div>
  )
}

export const LoadingSpinnerWithText: FC<ISpinnerTextProps> = ({
  title,
  variant,
}) => {
  return (
    <Typography variant={variant} color="primary" style={{ margin: '15px 0' }}>
      <CircularProgress
        color="inherit"
        size={25}
        style={{ marginRight: '15px' }}
      />
      {title}
    </Typography>
  )
}
